export const CLIENT_ROOT = '/dashboard-client';
export const PATIENT_ROOT = '/dashboard-client';
